//
//
//
//
//
//
//
//

import Vue from 'vue';
import Slick from 'vue-slick';
import longArrowLeft from 'images/longArrowLeftWhite.png';
import longArrowRight from 'images/longArrowRightWhite.png';

export default {
  props: {
    agents: {
      type: Array,
    },
  },
  data: function() {
    return {
      slickOptions: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        prevArrow: `<button class="button button--prev">
          <img src="${longArrowLeft}" /> prev
        </button>`,
        nextArrow: `<button class="button button--next">
          next <img src="${longArrowRight}" />
        </button>`,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: 'unslick',
          },
        ],
      },
    };
  },
  methods: {
    agentClickHandler: function(agent) {
      if (this.shouldShowModalOnClick) {
        AgentModalBus.$emit(OpenAgentModalEvent, agent);
      }
    },
  },
  components: {
    slick: Slick,
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/projects-carousel/ProjectsCarousel.vue